import { useCallback, useEffect, useState } from 'react';
import { hrApi } from '@/api';
import { PageHeader } from '@/components/layout/PageHeader';
import { RecordDataTable } from '@/components/ui/RecordDataTable';
import { showApiError } from '@/utils/apiError';

export function HrAdminConfigPage() {
  const [fieldPerms, setFieldPerms] = useState<unknown[]>([]);
  const [countryPacks, setCountryPacks] = useState<unknown[]>([]);
  const [rotations, setRotations] = useState<unknown[]>([]);

  const load = useCallback(async () => {
    try {
      setFieldPerms(await hrApi.listFieldPermissions());
      setCountryPacks(await hrApi.listCountryPacks());
      setRotations(await hrApi.listShiftRotations());
    } catch (err) {
      showApiError(err, 'Failed to load admin config');
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <div>
      <PageHeader title="HR admin" description="Field permissions, country packs, shift rotation patterns" breadcrumbs={[{ label: 'HR', to: '/hr' }, { label: 'Admin' }]} />
      <div className="grid gap-4 lg:grid-cols-3">
        <section className="card p-4">
          <h3 className="font-semibold">Field permissions</h3>
          <RecordDataTable data={fieldPerms} embedded emptyTitle="No field permissions" />
        </section>
        <section className="card p-4">
          <h3 className="font-semibold">Country packs</h3>
          <RecordDataTable data={countryPacks} embedded emptyTitle="No country packs" />
        </section>
        <section className="card p-4">
          <h3 className="font-semibold">Shift rotations</h3>
          <RecordDataTable data={rotations} embedded emptyTitle="No shift rotations" />
        </section>
      </div>
    </div>
  );
}
